import { List, ListItem, ListItemText, styled } from '@mui/material'
import { Link } from 'react-router-dom'
import useBucketShareAlbums from '../../../hooks/useBucketShareAlbums'
import useBucketShareById from '../../../hooks/useBucketShareById'

const AlbumLink = styled(Link)(({ theme }) => ({
  display: 'block',
  width: '100%',
  fontSize: '1rem',
  '&:hover': { color: theme.palette.primary.main },
  textAlign: 'left',
  textDecoration: 'none',
  color: 'black'
}))

function SubAlbumList({ shareId, albumId }: { shareId?: string; albumId: string }) {
  const { bucketShare } = useBucketShareById()
  const { items } = useBucketShareAlbums(bucketShare, albumId)

  return (
    <List>
      {items.map((subAlbum) => (
        <ListItem key={subAlbum.id}>
          <AlbumLink to={`/share/${shareId}/album/${subAlbum.id}`}>
            <ListItemText primary={subAlbum.title} />
          </AlbumLink>
        </ListItem>
      ))}
    </List>
  )
}

export default SubAlbumList

SubAlbumList.defaultProps = {
  shareId: ''
}
